import {NgxLoggerLevel} from 'ngx-logger';
import {TimezoneType} from 'src/app/enums/timezone-type';
import {AppGuardType} from 'src/app/tinea-components/okta/enum/AppGuardType';
import {DataConsumeType} from 'src/app/tinea-components/okta/enum/DataConsumeType';
import packageInfo from '../../package.json';
import {coreEnvironment} from './core/core.environment';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    core: coreEnvironment,
    production: false,
    VERSION: packageInfo.version,
    timezone: TimezoneType.LOCAL,
    versionNameInSession: 'version',
    apiUrl: '/web',
    // logs
    disableConsoleLogging: false,
    browserLogLevel: NgxLoggerLevel.TRACE,
    serverLogLevel: NgxLoggerLevel.LOG,
    // encryption
    encryptUserSession: false,
    encryptionSecretKey: '!j5;/q3XsBxA5@,78CLPAw_[TP[.@L67ddf?6bh;?#]&U',
    // auth
    authClass: 'CustomOktaService',
    authAppGuard: AppGuardType.AUTHENTICATED_BY_CUSTOM_OKTA_THEN_LOGGEDIN,
    authLoginInternal: false,                               // eg. login by internal form (true) ? or by an other website (false) ?
    authRedirectToPreviousUrl: true,
    authPathRedirectAfterLogin: '/',
    authPathRedirectAfterLogout: '/',
    authPathLoggedInCallback: 'logged-in-callback',
    // key names
    authRedirectToNameInSession: 'redirectTo',
    authTokenNameInSession: 'authToken',
    authUserNameInSession: 'user',
    authExpireAtNameInSession: 'authExpireAt',
    // consumes api
    dataStartApiCall: ['/web'],
    dataConsumeType: DataConsumeType.AUTH,
    dataHeaders: [{nameInEnv: null, headerName: 'Authorization', mustDecode: false, fieldToDecode: 'uid'}], // data needed in header for consume data [ {nameInEnv: null, headerName: 'Authorization',mustDecode: false, fieldToDecode: null} ]
    userId: 'root',
    // key names
    dataTokenTypeNameInSession: 'tokenType',
    dataTokenTypeValueInSession: 'Bearer',
    dataTokenNameInSession: 'dataToken',
    // okta
    okta_client_id: '0oa5ulxvi9UoIIPtP0i7',
    okta_domain: 'https://tinea.okta-emea.com',
    okta_issuer: `https://tinea.okta-emea.com/oauth2/aush086dobTtGVoH60i7`,
    okta_redirectUri: window.location.origin + '/implicit/callback',
    // okta_redirectUri: window.location.origin + '/implicit/callback',
    okta_scope: 'shiva openid',
    brand_name: 'SHIVA LNG',
    // okta custom
    oktaCustom: {
        okta_client_id: '0oa5ulxvi9UoIIPtP0i7',
        okta_domain: 'https://tinea.okta-emea.com',
        okta_issuer: 'https://tinea.okta-emea.com/oauth2/aush086dobTtGVoH60i7',
        response_type: 'code',
        redirect_uri: window.location.origin + '/implicit/custom-callback',
        post_logout_redirect_uri: window.location.origin + '/',
        scopes: 'lng openid',
        state: 'YYYY',
        nonce: 'YYYY',
        code_challenge: 'qrvgapdkr4CEacapa6oYCcU7BmDKBOApC2PHAAndgGY',
        code_verifier: 'id72dKsrgJQltBfrXkKu-0z-BHZCg5hmSsodywdn1VxeAGcjj9k4RxGjrAOGcxK4Lq8i3U7sssbx1D4bNIhEpcx_B5ohFc2-O1dcTbrvq_~2Ygr9aKku2dEPQHLku1g_',
        code_challenge_method: 'S256',
        grant_type: 'authorization_code'
    },
    // api manager
    getTokenBodyParams: JSON.stringify(['grant_type=urn:ietf:params:oauth:grant-type:jwt-bearer', 'assertion']),
    application: '',
    // keyId: 'a01f30b7-9080-4b37-913d-f0bc9587e14f',
    client_id: '',
    // client_secret: '707c516d-6353-42b3-b42f-863b14c1109f',
    tineaTokenUrl: '',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
